export default "__VITE_ASSET__Df$TaR0U__"